// Compute a unit's combat stats from the shared API dictionaries — the same
// derivation InlineUnit/HoverUnit do via computeds, as a pure function so the
// fight view can compute stats for any unit.
//
// charStats, itemschanged, notAbles.movementSkills are the safeDict-wrapped
// lookups built in Luxstadio (missing keys return zero-filled defaults).

export function unitCombatStats(unit, charStats, itemschanged, notAbles) {
  const classKey = (unit.Class || '').replace(/\s+/g, '') + (unit.Gender || '');
  const classBase = charStats[classKey];
  const equipped = {
    Mainhand:  itemschanged[unit.Mainhand],
    Offhand:   itemschanged[unit.Offhand],
    Head:      itemschanged[unit.Head],
    Armor:     itemschanged[unit.Armor],
    Accessory: itemschanged[unit.Accessory],
  };
  const sum = (k) => equipped.Mainhand[k] + equipped.Offhand[k] + equipped.Head[k] + equipped.Armor[k] + equipped.Accessory[k];
  const moveSkill = notAbles.movementSkills[unit.MoveSkill];
  const stats = {
    hp:    classBase.hp    + sum('hp'),
    mp:    classBase.mp    + sum('mp'),
    pa:    classBase.pa    + sum('pa'),
    ma:    classBase.ma    + sum('ma'),
    speed: classBase.speed + sum('speed'),
    move:  classBase.move  + sum('move') + moveSkill.move,
    jump:  classBase.jump  + sum('jump') + moveSkill.jump,
  };
  const paUnarmed = classBase.pa + equipped.Head.pa + equipped.Armor.pa + equipped.Accessory.pa;
  return { classBase, equipped, stats, paUnarmed };
}
